export default "__VITE_ASSET__CForFu11__"